import React, { useState, useEffect, useMemo, useContext } from "react";
import { Formik, Form } from "formik";
import { Button, TextField, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@mui/material";
import { workAPI } from "../../services/WorkService";
import { gmAPI } from "../../services/GroupMailService";
import { useDropzone } from "react-dropzone";
import { AppContext } from "./../../contexts/appContext";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Download from "downloadjs";
import ChatBox from "./../Detail_Work_ChatComment/index";
import { Clear } from "@material-ui/icons";

export const Update_Work_From = ({
  data,
  setData,
  _id,
  comment,
  chatUser,
  open,
  setOpen,
  newZ,
}) => {
  let history = useHistory();
  const token = localStorage.getItem("Token");
  const { user, socket } = useContext(AppContext);
  const [type, setType] = useState([]);
  const [template, setTemplate] = useState([]);
  const [force, setForce] = useState(0);
  const [workLoading, setWorkLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [Org, setOrg] = useState([]);
  const [groupMail, setGroupMail] = useState([]);

  useEffect(() => {
    if (data && data.group_mail && Array.isArray(data.group_mail)) {
      setGroupMail(data.group_mail);
    }

    return () => {
      if (groupMail.length > 0) {
        setGroupMail([]);
      }
    };
  }, [data]);

  const useStyles = makeStyles((theme) => ({
    chatContainer: {
      margin: "auto",
      border: "1px solid lightgray",
      borderRadius: "10px",
      height: open ? "50vh" : "5vh",
      width: "20vw",
      zIndex: 100000,
      [theme.breakpoints.down(1341)]: {
        width: "80%",
      },
    },
    chatHeader: {
      borderRadius: open ? "0" : "10px",
      color: "#fff",
      cursor: "pointer",
      backgroundColor: newZ == 0 ? "#6ab23a" : "#f27474",
      height: open ? "10%" : "100%",
      textAlign: "center",
      verticalAlign: "middle",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    workAPI
      .GetType(token, { use: "YES" })
      .then((res) => {
        if (res.status == 200) {
          if (Array.isArray(res.message)) {
            setType(res.message);
          }
          if (Array.isArray(res.message2)) {
            setTemplate(res.message2);
          }
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 10000,
          }).then(() => {
            setForce((old) => old + 1);
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 10000,
        }).then(() => {
          setForce((old) => old + 1);
        });
      });
  }, [force]);

  const findTypeLink = (parames) => {
    let typeFind = type.find((res) => res.type_name == parames);
    if (typeFind && typeFind.is_link) return true;
    else return false;
  };

  const findTypeEmail = (parames) => {
    let typeFind = type.find((res) => res.type_name == parames);
    if (typeFind && typeFind.email) return true;
    else return false;
  };

  const SelectFile = ({ type }) => {
    return (
      <Autocomplete
        options={template
          .filter((res) => res.type == type)
          .map((option, index) => {
            return { id: index, name: option.template_file_show };
          })}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        getOptionLabel={(option) => option.name || ""}
        onChange={(event, newValue) => {
          let find_id = template
            .filter((res) => res.type == type)
            .find((res) => res.template_file_show == newValue.name);
          if (find_id) {
            workAPI
              .DownloadTemplateFile(token, find_id._id)
              .then((response) => {
                if (response.status == 200) {
                  Download(
                    response.data,
                    newValue.name,
                    response.headers["content-type"]
                  );
                } else {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${response.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 3000,
                  });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${error.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 3000,
                });
              });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Download file template..."
            variant="standard"
          />
        )}
      />
    );
  };

  const SelectFile_Retail = ({ type }) => {
    return (
      <Autocomplete
        options={
          data.file_fisrt.length > 0
            ? [{ id: "All", name: "Download All", ref: "Download All" }].concat(
                data.file_fisrt.map((option, index) => {
                  return {
                    id: index,
                    name: option.name_show,
                    ref: option.name_real,
                  };
                })
              )
            : data.file_fisrt.map((option, index) => {
                return {
                  id: index,
                  name: option.name_show,
                  ref: option.name_real,
                };
              })
        }
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        getOptionLabel={(option) => option.name || ""}
        onChange={(event, newValue) => {
          if (newValue.id == "All") {
            data.file_fisrt.map((response) => {
              let find_id = data.file_fisrt.find(
                (res) => res.name_real == response.name_real
              );
              if (find_id) {
                workAPI
                  .DownloadWorklFile(token, response.name_real, type)
                  .then((responseZ) => {
                    if (responseZ.status == 200) {
                      Download(
                        responseZ.data,
                        response.name_show,
                        responseZ.headers["content-type"]
                      );
                    } else {
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${response.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 3000,
                      });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${error.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 3000,
                    });
                  });
              }
            });
          } else {
            let find_id = data.file_fisrt.find(
              (res) => res.name_real == newValue.ref
            );
            if (find_id) {
              workAPI
                .DownloadWorklFile(token, find_id.name_real, type)
                .then((response) => {
                  if (response.status == 200) {
                    Download(
                      response.data,
                      newValue.name,
                      response.headers["content-type"]
                    );
                  } else {
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${response.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 3000,
                    });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 3000,
                  });
                });
            }
          }
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label={`Download file ${type}...`}
              variant="standard"
            />
          );
        }}
      />
    );
  };

  const SelectFile_Support = ({ type }) => {
    return (
      <Autocomplete
        options={
          data.file_second.length > 0
            ? [{ id: "All", name: "Download All", ref: "Download All" }].concat(
                data.file_second.map((option, index) => {
                  return {
                    id: index,
                    name: option.name_show,
                    ref: option.name_real,
                  };
                })
              )
            : data.file_second.map((option, index) => {
                return {
                  id: index,
                  name: option.name_show,
                  ref: option.name_real,
                };
              })
        }
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        getOptionLabel={(option) => option.name || ""}
        onChange={(event, newValue) => {
          if (newValue.id == "All") {
            data.file_second.map((response) => {
              let find_id = data.file_second.find(
                (res) => res.name_real == response.name_real
              );
              if (find_id) {
                workAPI
                  .DownloadWorklFile(token, response.name_real, type)
                  .then((responseZ) => {
                    if (responseZ.status == 200) {
                      Download(
                        responseZ.data,
                        response.name_show,
                        responseZ.headers["content-type"]
                      );
                    } else {
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${response.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 3000,
                      });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${error.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 3000,
                    });
                  });
              }
            });
          } else {
            let find_id = data.file_second.find(
              (res) => res.name_real == newValue.ref
            );
            if (find_id) {
              workAPI
                .DownloadWorklFile(token, find_id.name_real, type)
                .then((response) => {
                  if (response.status == 200) {
                    Download(
                      response.data,
                      newValue.name,
                      response.headers["content-type"]
                    );
                  } else {
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${response.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 3000,
                    });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 3000,
                  });
                });
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`Download file ${type}...`}
            variant="standard"
          />
        )}
      />
    );
  };

  const statusChange = (status) => {
    switch (status) {
      case "On Process":
        return "Pending";
      case "Close":
        return "Accept";
      default:
        return status;
    }
  };

  const DeleteFileByIndex = (index) => {
    let fileZ = file.filter((res, i) => i != index);
    setFile(fileZ);
  };

  const DropZoneComponents = (props) => {
    const activeStyle = {
      borderColor: "#2196f3",
    };

    const acceptStyle = {
      borderColor: "#00e676",
    };

    const rejectStyle = {
      borderColor: "#ff1744",
    };

    const {
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject,
    } = useDropzone({
      maxFiles: 20,
      // accept: 'image/jpeg, image/png',
      onDrop: (acceptedFiles) => {
        setFile((old) => [...old, ...acceptedFiles]);
      },
    });
    const style = useMemo(
      () => ({
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }),
      [isDragActive, isDragReject, isDragAccept]
    );

    const acceptedFileItems = file
      .filter((res, i) => i <= 19)
      .map((file, i) => (
        <li key={i}>
          {file.path} - {file.size} bytes{" "}
          <Clear
            style={{ color: "red", fontSize: 16, cursor: "pointer" }}
            onClick={() => DeleteFileByIndex(i)}
          />
        </li>
      ));

    const fileRejectionItems = file
      .filter((res, i) => i > 19)
      .map((file, i) => {
        return (
          <li key={i}>
            {file.path} - {file.size} bytes{" "}
            <Clear
              style={{ color: "red", fontSize: 16, cursor: "pointer" }}
              onClick={() => DeleteFileByIndex(i)}
            />
            <ul>
              <li>ไฟล์ที่เกิน</li>
            </ul>
          </li>
        );
      });

    return (
      <>
        <section
          className="container uploadBox jobsorrymt1"
          {...getRootProps({ style, onClick: (evt) => evt.preventDefault() })}
        >
          <div
            {...getRootProps({
              className: "dropzone",
              onClick: (evt) => evt.preventDefault(),
            })}
          >
            <input {...getInputProps()} />
            <p>Support เลือกไฟล์หรือลากไฟล์เพื่ออัพโหลดไฟล์ (สูงสุด 20 ไฟล์)</p>
          </div>
        </section>
        <aside>
          {acceptedFileItems.length >= 1 && (
            <div>
              <h5>
                Accepted files{" "}
                <Clear
                  style={{ color: "red", fontSize: 18, cursor: "pointer" }}
                  onClick={() => setFile([])}
                />
              </h5>
              <ul>{acceptedFileItems}</ul>
            </div>
          )}
          {fileRejectionItems.length >= 1 && (
            <div>
              <h5>Rejected files</h5>
              <ul>{fileRejectionItems}</ul>
            </div>
          )}
        </aside>
      </>
    );
  };

  const DropZoneComponentZ = (props) => {
    const activeStyle = {
      borderColor: "#2196f3",
    };

    const acceptStyle = {
      borderColor: "#00e676",
    };

    const rejectStyle = {
      borderColor: "#ff1744",
    };

    const {
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject,
    } = useDropzone({
      maxFiles: 20,
      // accept: 'image/jpeg, image/png',
      onDrop: (acceptedFiles) => {
        setFile((old) => [...old, ...acceptedFiles]);
      },
    });
    const style = useMemo(
      () => ({
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }),
      [isDragActive, isDragReject, isDragAccept]
    );
    const acceptedFileItems = file
      .filter((res, i) => i <= 19)
      .map((file, i) => (
        <li key={i}>
          {file.path} - {file.size} bytes{" "}
          <Clear
            style={{ color: "red", fontSize: 16, cursor: "pointer" }}
            onClick={() => DeleteFileByIndex(i)}
          />
        </li>
      ));

    const fileRejectionItems = file
      .filter((res, i) => i > 19)
      .map((file, i) => {
        return (
          <li key={i}>
            {file.path} - {file.size} bytes{" "}
            <Clear
              style={{ color: "red", fontSize: 16, cursor: "pointer" }}
              onClick={() => DeleteFileByIndex(i)}
            />
            <ul>
              <li>ไฟล์ที่เกิน</li>
            </ul>
          </li>
        );
      });

    return (
      <>
        <section
          className="container uploadBox jobsorrymt1"
          {...getRootProps({ style, onClick: (evt) => evt.preventDefault() })}
        >
          <div
            {...getRootProps({
              className: "dropzone",
              onClick: (evt) => evt.preventDefault(),
            })}
          >
            <input {...getInputProps()} />
            <p>Retail เลือกไฟล์หรือลากไฟล์เพื่ออัพโหลดไฟล์ (สูงสุด 20 ไฟล์)</p>
          </div>
        </section>
        <aside>
          {acceptedFileItems.length >= 1 && (
            <div>
              <h5>
                Accepted files{" "}
                <Clear
                  style={{ color: "red", fontSize: 18, cursor: "pointer" }}
                  onClick={() => setFile([])}
                />
              </h5>
              <ul>{acceptedFileItems}</ul>
            </div>
          )}
          {fileRejectionItems.length >= 1 && (
            <div>
              <h5>Rejected files</h5>
              <ul>{fileRejectionItems}</ul>
            </div>
          )}
        </aside>
      </>
    );
  };

  const sendMail = (values) => {
    try {
      setEmailLoading(true);
      let form = new FormData();
      let email_value = values.email_address;
      let message_value = values.email_text;
      if (!email_value) throw { message: "Email is require." };
      let email_split = email_value.split(",");
      let turnemail = email_split.map((res) => {
        let string = res.trim();
        string = res.replace(/\s/g, "");
        return string;
      });
      let checkformat = turnemail.find(
        (res) =>
          !res.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      );
      if (checkformat) throw { message: `${checkformat} is not Email format` };
      form.append("_id", values._id);
      form.append("email_address", turnemail.join(","));
      form.append("email_text", message_value || "");

      if (Array.isArray(groupMail) && groupMail.length > 0) {
        form.append("group_mail", JSON.stringify(groupMail));
      } else {
        form.append("group_mail", JSON.stringify([]));
      }
      workAPI
        .SendEmail(form)
        .then((res) => {
          if (res.status == 200) {
            setData((old) => ({ ...old, sendMail: true }));
            Swal.fire({
              icon: "success",
              confirmButtonColor: "#6ab23a",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switchZ",
              },
              width: "28rem",
              timer: 3000,
            });
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        })
        .finally(() => {
          setEmailLoading(false);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 10000,
      }).then(() => {
        setEmailLoading(false);
      });
    }
  };

  const deleteMail = (values) => {
    try {
      setEmailLoading(true);
      workAPI
        .DeleteEmail({ _id: values._id })
        .then((res) => {
          if (res.status == 200) {
            setData((old) => ({ ...old, sendMail: false }));
            Swal.fire({
              icon: "success",
              confirmButtonColor: "#6ab23a",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switchZ",
              },
              width: "28rem",
              timer: 3000,
            });
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        })
        .finally(() => {
          setEmailLoading(false);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 10000,
      }).then(() => {
        setEmailLoading(false);
      });
    }
  };

  const forceMail = (values) => {
    try {
      setEmailLoading(true);
      workAPI
        .ForceEmail({ _id: values._id })
        .then((res) => {
          if (res.status == 200) {
            setData((old) => ({ ...old, sendMail: false }));
            Swal.fire({
              icon: "success",
              confirmButtonColor: "#6ab23a",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switchZ",
              },
              width: "28rem",
              timer: 3000,
            });
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        })
        .finally(() => {
          setEmailLoading(false);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 10000,
      }).then(() => {
        setEmailLoading(false);
      });
    }
  };

  useEffect(() => {
    if (type.length > 0 && data.type && findTypeEmail(data.type)) {
      gmAPI
        .getOrgUnitName()
        .then((res) => {
          if (res.status == 200) {
            setOrg(res.message);
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        });
    }
    return () => {
      if (Org.length > 0) {
        setOrg([]);
      }
    };
  }, [data, type]);

  const GroupMailChange = (event, values) => {
    setGroupMail(values);
  };

  return (
    <Formik
      initialValues={{ ...data }}
      enableReinitialize
      onSubmit={async (values) => {
        try {
          if (!values.status) throw { message: "เลือกสถานะด้วย" };
          if (!values.type) throw { message: "ประเภทว่าง" };
          try {
            setWorkLoading(true);
            let form = new FormData();
            form.append("_id", values._id);
            form.append("status", statusChange(values.status));
            if (file && Array.isArray(file) && file.length >= 1) {
              form.append("user_second", user.username);
              file
                .filter((res, i) => i <= 19)
                .map((res, i) => {
                  form.append(`file_second${i}`, res);
                });
            }

            if (
              findTypeEmail(values.type) &&
              Array.isArray(groupMail) &&
              groupMail.length > 0
            ) {
              form.append("group_mail", JSON.stringify(groupMail));
            } else {
              form.append("group_mail", JSON.stringify([]));
            }

            if (findTypeEmail(values.type) && values.email_address) {
              let email_split = values.email_address.split(",");
              let turnemail = email_split.map((res) => {
                let string = res.trim();
                string = res.replace(/\s/g, "");
                return string;
              });
              let checkformat = turnemail.find(
                (res) =>
                  !res.match(
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  )
              );
              if (checkformat)
                throw { message: `${checkformat} is not Email format` };
              form.append("email_address", turnemail.join(","));
              form.append("email_text", values.email_text || "");
            }
            workAPI
              .UpdateWork(token, form)
              .then((res) => {
                if (res.status == 200) {
                  socket.emit("SendNotification", {
                    _id: values._id,
                    notification_obj: {
                      is_read: false,
                      title:
                        "อัพเดทสถานะจาก " + values.title + " " + values.type,
                      detail: `อัพเดทสถานะ`,
                      sender: user.username,
                      push_to: `/detail-work/${values._id}`,
                    },
                  });
                  if (res._id) {
                    socket.emit("UpdateWork", { _id: res._id });
                  }
                  Swal.fire({
                    icon: "success",
                    confirmButtonColor: "#6ab23a",
                    html: `<span class="colorWhite">${res.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switchZ",
                    },
                    width: "28rem",
                    timer: 3000,
                  }).then(() => {
                    history.push("/");
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${res.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 5000,
                  });
                }
                setWorkLoading(false);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${error.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 5000,
                }).then(() => {
                  setWorkLoading(false);
                });
              });
          } catch (error) {
            setWorkLoading(false);
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${error.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 3000,
            });
          }
        } catch (error) {
          setWorkLoading(false);
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      }}
    >
      {({ values, handleChange, setFieldValue, touched, errors }) => (
        <Form style={{ display: !user ? "none" : "block" }}>
          {user.get_work && user.username != values.user_second && (
            <Button
              variant="contained"
              style={{
                margin: "0.5% 0",
                backgroundColor:
                  user.role == "Retail" ? "lightgray" : "rgb(91, 184, 70)",
                color: "whitesmoke",
              }}
              size="small"
              onClick={() => {
                workAPI
                  .checkFileSecond({ _id: values._id })
                  .then((res) => {
                    if (res.status == 200) {
                      Swal.fire({
                        title: "คุณแน่ใจ ?",
                        text: `ยืนยันที่จะรับงานนี้ ?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#56A834",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "แน่ใจ",
                        cancelButtonText: "ยังก่อน",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          workAPI
                            .assistWork({
                              _id: values._id,
                              username: user.username,
                            })
                            .then((res) => {
                              if (res.status != 200)
                                throw { message: res.message };
                              Swal.fire({
                                icon: "success",
                                confirmButtonColor: "#6ab23a",
                                html: `<span class="colorWhite">รับงานเรียบร้อยแล้ว</span>`,
                                backdrop: "transparent",
                                background: "rgba(0,0,0,.75)",
                                customClass: {
                                  icon: "switchZ",
                                },
                                width: "28rem",
                                timer: 3000,
                              }).then(() => {
                                socket.emit("UpdateWork", { _id: values._id });
                                setData(res.message);
                                setFieldValue("user_second", user.username);
                                setFieldValue("status", "On Process");
                              });
                            })
                            .catch((error) => {
                              Swal.fire({
                                icon: "error",
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${error.message}</span>`,
                                backdrop: "transparent",
                                background: "rgba(0,0,0,.75)",
                                customClass: {
                                  icon: "switch",
                                },
                                width: "28rem",
                                timer: 5000,
                              });
                            });
                        }
                      });
                    } else if (res.status == 201) {
                      Swal.fire({
                        title: "คุณแน่ใจ ?",
                        text: res.message,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#56A834",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "แน่ใจ",
                        cancelButtonText: "ยังก่อน",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          workAPI
                            .assistWork({
                              _id: values._id,
                              username: user.username,
                            })
                            .then((res) => {
                              if (res.status != 200)
                                throw { message: res.message };
                              Swal.fire({
                                icon: "success",
                                confirmButtonColor: "#6ab23a",
                                html: `<span class="colorWhite">รับงานเรียบร้อยแล้ว</span>`,
                                backdrop: "transparent",
                                background: "rgba(0,0,0,.75)",
                                customClass: {
                                  icon: "switchZ",
                                },
                                width: "28rem",
                                timer: 3000,
                              }).then(() => {
                                socket.emit("UpdateWork", { _id: values._id });
                                setData(res.message);
                                setFieldValue("user_second", user.username);
                                setFieldValue("status", "On Process");
                              });
                            })
                            .catch((error) => {
                              Swal.fire({
                                icon: "error",
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${error.message}</span>`,
                                backdrop: "transparent",
                                background: "rgba(0,0,0,.75)",
                                customClass: {
                                  icon: "switch",
                                },
                                width: "28rem",
                                timer: 5000,
                              });
                            });
                        }
                      });
                    } else {
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 5000,
                      });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${error.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 5000,
                    });
                  });
              }}
            >
              รับงานนี้
            </Button>
          )}
          <div className="form-outline mb-4">
            <TextField
              fullWidth
              label="Type..."
              name="title"
              value={values.type || ""}
              onChange={handleChange}
              disabled
            />
          </div>
          <div className="form-outline mb-4">
            <TextField
              fullWidth
              label="Title..."
              name="title"
              value={values.title || ""}
              onChange={handleChange}
              disabled
            />
            {errors.title && touched.title ? (
              <div style={{ color: "#FF3333" }}>{errors.title}</div>
            ) : null}
          </div>
          {values.type && findTypeLink(values.type) && (
            <div className="form-outline mb-4" style={{ cursor: "pointer" }}>
              {values.link.split(",").map((xxx, i) => (
                <TextField
                  fullWidth
                  label="Google Drive link..."
                  key={i}
                  name="link"
                  className="pointer"
                  value={xxx || ""}
                  style={{ marginTop: "5px" }}
                  onClick={() => window.open(xxx)}
                  onChange={handleChange}
                  disabled
                />
              ))}
              {errors.link && touched.link ? (
                <div style={{ color: "#FF3333" }}>{errors.link}</div>
              ) : null}
            </div>
          )}
          {values.status && (
            <div className="form-outline mb-4">
              <Autocomplete
                disabled={user.role == "Retail"}
                value={values.status}
                options={["On Process", "Close", "Decline"]}
                onChange={(event, newValue) => {
                  setFieldValue("status", newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Status..." variant="standard" />
                )}
              />
            </div>
          )}
          {values.type && (
            <div className="form-outline mb-4">
              <SelectFile type={values.type} />
            </div>
          )}
          {findTypeEmail(values.type) && (
            <div className="form-outline mb-4">
              <Autocomplete
                multiple
                options={Org}
                onChange={GroupMailChange}
                value={groupMail}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Group Mail..."
                    variant="standard"
                  />
                )}
              />{" "}
            </div>
          )}
          {findTypeEmail(values.type) && (
            <div className="form-outline mb-4">
              <TextField
                name="email_address"
                fullWidth
                label="Mail Address ส่งไม่เกิน 3 คนใส่ , คั่น"
                value={values.email_address || ""}
                onChange={handleChange}
                disabled={
                  !findTypeEmail(values.type) ||
                  (user.role != "Retail" && values.user_second != user.username)
                }
              />
            </div>
          )}
          {findTypeEmail(values.type) && (
            <div className="form-outline mb-4">
              <TextField
                fullWidth
                label="Mail Message..."
                name="email_text"
                value={values.email_text || ""}
                onChange={handleChange}
                disabled={
                  !findTypeEmail(values.type) ||
                  (user.role != "Retail" && values.user_second != user.username)
                }
              />
            </div>
          )}
          {data && data.file_fisrt && Array.isArray(data.file_fisrt) && (
            <div className="form-outline mb-4">
              <SelectFile_Retail type="Retail" />
            </div>
          )}
          {data &&
            data.file_second &&
            Array.isArray(data.file_second) &&
            data.file_second.length >= 1 && (
              <div className="form-outline mb-4">
                <SelectFile_Support type="Support" />
              </div>
            )}
          <div className={classes.chatContainer}>
            <div
              className={classes.chatHeader}
              onClick={() => setOpen((old) => !old)}
            >
              {newZ != 0 ? (
                <span style={{ verticalAlign: "middle" }}>
                  New Message {newZ}
                </span>
              ) : (
                <span style={{ verticalAlign: "middle" }}>{chatUser}</span>
              )}
            </div>
            {open && <ChatBox _id={_id} comment={comment} data={data} />}
          </div>
          <div
            className="form-outline mb-4"
            style={{ margin: "auto", width: "80%", marginTop: "1.5%" }}
          >
            {user.role == "Retail" ? (
              values.status == "New" && (
                <DropZoneComponentZ setFieldValue={setFieldValue} />
              )
            ) : (
              <DropZoneComponents setFieldValue={setFieldValue} />
            )}
          </div>
          {values.user_second == user.username && !emailLoading && (
            <Button
              type="submit"
              variant="contained"
              style={{
                textTransform: "none",
                margin: "2%",
                backgroundColor:
                  workLoading ||
                  values.status == "Accept" ||
                  (user.role != "Support" &&
                    values.user_second != user.username)
                    ? "lightgray"
                    : "rgb(91, 184, 70)",
                color: "whitesmoke",
              }}
              size="small"
              disabled={workLoading}
            >
              {!workLoading ? (
                "Submit"
              ) : (
                <CircularProgress
                  size={24}
                  style={{ color: "rgb(106, 178, 58)" }}
                />
              )}
            </Button>
          )}
          {findTypeEmail(values.type) &&
            data.status == "Close" &&
            !workLoading && (
              <Button
                variant="contained"
                style={{
                  textTransform: "none",
                  margin: "2%",
                  backgroundColor:
                    workLoading ||
                    !!data.sendMail ||
                    values.status == "Accept" ||
                    values.user_second != user.username
                      ? "lightgray"
                      : "rgb(91, 184, 70)",
                  color: "whitesmoke",
                }}
                size="small"
                disabled={
                  emailLoading ||
                  values.user_second != user.username ||
                  !!data.sendMail
                }
                onClick={(e) => {
                  e.preventDefault();
                  sendMail(values);
                }}
              >
                {!emailLoading ? (
                  "Send Mail"
                ) : (
                  <CircularProgress
                    size={24}
                    style={{ color: "rgb(106, 178, 58)" }}
                  />
                )}
              </Button>
            )}
          {findTypeEmail(values.type) &&
            data.status == "Close" &&
            !workLoading && (
              <Button
                variant="contained"
                style={{
                  textTransform: "none",
                  margin: "2%",
                  backgroundColor:
                    workLoading ||
                    !data.sendMail ||
                    values.status == "Accept" ||
                    values.user_second != user.username
                      ? "lightgray"
                      : "#ef4444",
                  color: "whitesmoke",
                }}
                size="small"
                disabled={
                  emailLoading ||
                  (user.role == "Admin"
                    ? false
                    : values.user_second != user.username) ||
                  !data.sendMail
                }
                onClick={(e) => {
                  e.preventDefault();
                  deleteMail(values);
                }}
              >
                {!emailLoading ? (
                  "Delete Mail"
                ) : (
                  <CircularProgress
                    size={24}
                    style={{ color: "rgb(106, 178, 58)" }}
                  />
                )}
              </Button>
            )}
          {findTypeEmail(values.type) &&
            data.status == "Close" &&
            !workLoading && (
              <Button
                variant="contained"
                style={{
                  textTransform: "none",
                  margin: "2%",
                  backgroundColor:
                    workLoading ||
                    !data.sendMail ||
                    values.status == "Accept" ||
                    values.user_second != user.username
                      ? "lightgray"
                      : "rgb(91, 184, 70)",
                  color: "whitesmoke",
                }}
                size="small"
                disabled={
                  emailLoading ||
                  (user.role == "Admin"
                    ? false
                    : values.user_second != user.username) ||
                  !data.sendMail
                }
                onClick={(e) => {
                  e.preventDefault();
                  forceMail(values);
                }}
              >
                {!emailLoading ? (
                  "ส่ง Mail ทันที"
                ) : (
                  <CircularProgress
                    size={24}
                    style={{ color: "rgb(106, 178, 58)" }}
                  />
                )}
              </Button>
            )}
        </Form>
      )}
    </Formik>
  );
};
